import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import UserStore from '~/glm/models/user-store';
import EventCollection from '~/glm/models/gds/event-collection';
import NamesCell from '~/glm/components/guest-list/cells/names-cell';
import PartyOfCell from '~/glm/components/guest-list/cells/party-of-cell';
import TextCell from '~/glm/components/guest-list/cells/text-cell.jsx';
import ContactInfoCell from '~/glm/components/guest-list/cells/contact-info-cell.jsx';
import RsvpsCell from '~/glm/components/guest-list/cells/rsvps-cell.jsx';
import { getPlaceholderHousehold } from '~/glm/components/guest-list/utils/placeholderHousehold';
import SelectionCellGroup from '~/glm/components/guest-list-table/cells/selection-cell-group';
import cellStyles from './guest-row.scss';
import styles from './row.scss';

@inject('userStore')
@observer
class DisabledOverviewHouseholdRow extends Component {
  constructor(props) {
    super(props);
    const { userStore } = props;

    this.household = getPlaceholderHousehold(userStore);
  }

  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    userStore: PropTypes.instanceOf(UserStore),
  };

  householdMembers = () => {
    return this.household.members.map(value => value);
  };

  get partyCount() {
    return this.householdMembers().length;
  }

  renderRsvpCells = () => {
    const { gdsEvents, gdsUiState } = this.props;
    return gdsEvents.nonReceptionEvents.map(gdsEvent => {
      const { id } = gdsEvent;

      return (
        <RsvpsCell
          key={id}
          disabled
          displayUninvitedGuests
          gdsUiState={gdsUiState}
          event={gdsEvent}
          invitations={this.household.guestInvitations(id)}
          guests={this.householdMembers()}
        />
      );
    });
  };

  renderSelectionCells = () => {
    const guests = this.householdMembers();

    return <SelectionCellGroup group={guests} />;
  };

  render() {
    return (
      <div key={`household-row-${this.household.id}`} className={styles.householdRow}>
        {this.renderSelectionCells()}
        <NamesCell disabled guests={this.householdMembers()} />
        <PartyOfCell disabled value={this.partyCount} />
        <ContactInfoCell disabled household={this.household} />
        {this.renderRsvpCells()}
        <TextCell disabled type="notes" value={this.household.coupleNote} className={cellStyles.notes} />
      </div>
    );
  }
}

export default DisabledOverviewHouseholdRow;
